import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=7e0c9f7f&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=7e0c9f7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e0c9f7f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e0c9f7f')) {
      api.createRecord('7e0c9f7f', component.options)
    } else {
      api.reload('7e0c9f7f', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=7e0c9f7f&scoped=true&", function () {
      api.rerender('7e0c9f7f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2yrJT3KKmu2fg/JS/comp/CookieBox.vue"
export default component.exports